<template>
  <MenuIcon :icon="icon">
    <v-list dense>
      <v-list-item
        v-for="(item, i) in items"
        :key="i"
        @click="$emit('itemMenuClicked', item[itemValue])"
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-icon v-if="itemActive == item.value" small left>mdi-check</v-icon>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </MenuIcon>
</template>

<script>
import MenuIcon from './MenuIcon';

export default {
  name: 'MenuIconList',
  props: {
    icon: {
      type: String,
      default: 'mdi-sort-variant'
    },
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemActive: {
      type: String,
      default: ''
    }
  },
  components: {
    MenuIcon
  }
}
</script>